"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./Text.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Text = function Text(props) {
  return /*#__PURE__*/_react["default"].createElement(_antd.Typography.Text, props);
};

var _default = Text;
exports["default"] = _default;